module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "rule"
  }, [_c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "tip-content"
  }, [_c('p', [_vm._v("1、下单金额每满1100元，获得抽奖机会1次，按1100元的倍数递增对应的抽奖次数，金额低于1100元，不计入抽奖资格。")]), _vm._v(" "), _c('p', [_vm._v("2、抽取后获得积分立即返还到个人积分账户中。")]), _vm._v(" "), _c('p', [_vm._v("3、地区专享折扣用户，暂不参与线上抽奖活动。")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-464e3f3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/lucky-drawer/components/Rule.vue
// module id = 610
// module chunks = 1